/*
 * @Description:
 * @Version: 1.0
 * @Autor: hekai
 * @Date: 2021-07-07 14:18:31
 * @LastEditors: hekai
 * @LastEditTime: 2021-07-07 14:25:54
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
// 引入图标
import '@/components/iconfont/iconfont.css'
import '@/components/iconfont/iconfont.js'
import store from './store'
import project from '@/components/project/index'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less' // or 'ant-design-vue/dist/antd.less'
import EasyProject from 'easy-project-vue'
import './style/tailwindcss.css'

Vue.use(project)
Vue.use(Antd)
Vue.use(EasyProject)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
